/* import __COLOCATED_TEMPLATE__ from './undo-send-delay-item.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    item: {
      text: string;
      isSelected: boolean;
    };
  };
}

const UndoSendDelayItem = templateOnlyComponent<Signature>();
export default UndoSendDelayItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::UndoSendDelayItem': typeof UndoSendDelayItem;
    'inbox2/composer/undo-send-delay-item': typeof UndoSendDelayItem;
  }
}
